var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-repeat=\"item in vm.tempAntraege\"><span>{{ $index + 1 }})</span><strong> {{ item.regelsatz_name }}</strong><span> von {{ item.crdate | date:'dd.MM.yyyy HH:mm'}}</span></div>");;return buf.join("");
}